import BlogFortySixContainer from "./container/BlogFortySixContainer";
export default BlogFortySixContainer;
